const STORAGE_KEY = 'driverAuth.smsSends'
const MAX_SENDS = 2
const WINDOW_MS = 60_000

interface SmsSend {
  phone: string
  at: number
}

let memorySends: SmsSend[] = []

const isSmsSend = (value: unknown): value is SmsSend =>
  typeof (value as SmsSend)?.phone === 'string' &&
  typeof (value as SmsSend)?.at === 'number'

const readSends = (): SmsSend[] => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return memorySends
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter(isSmsSend) : []
  } catch {
    return memorySends
  }
}

const writeSends = (sends: SmsSend[]) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(sends))
  } catch {
    memorySends = sends
  }
}

const recentSends = (now: number) =>
  readSends()
    .filter(({ at }) => at > now - WINDOW_MS)
    .sort((a, b) => a.at - b.at)

export const getCooldownEndsAt = (now = Date.now()): number | null => {
  const sends = recentSends(now)
  if (sends.length < MAX_SENDS) return null
  return sends[sends.length - MAX_SENDS].at + WINDOW_MS
}

export const recordCodeSent = (phone: string, now = Date.now()) => {
  writeSends([...recentSends(now), { phone, at: now }])
}

export const wasCodeRecentlySent = (phone: string, now = Date.now()) =>
  recentSends(now).some((send) => send.phone === phone)

export const formatCooldown = (seconds: number) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`
